<template>
  <a-config-provider :locale="locale">
    <div
      :class="{'index-wrapper-white':mainBGC,'minWidth':minWidth}"
      class="index-wrapper"
      style="min-height:100vh"
    >
      <div
        ref="header"
        class="header wrapper-back"
      >
        <div class="header-main">
          <div class="index_logo">
            <img v-if="indexLogoUrl" style="max-height: 60px" :src="indexLogoUrl">
          </div>
          <div
            class="header-main-content"
            style="display:flex; align-items: center;"
          >
            <div>
              <a-menu
                v-model="current"
                mode="horizontal"
              >
                <a-menu-item key="mail">
                  <router-link to="/">{{ $t('index.index') }}</router-link>
                </a-menu-item>
                <!-- <a-menu-item>
              <router-link :to="{path: '/order', query: {type: 'ordinary' }}">{{$t('index.order_center')}}</router-link>
                </a-menu-item>-->
                <!-- <a-sub-menu>
              <span slot="title">{{$t('index.self_service')}}</span>
                <a-menu-item key="special_booth">{{$t('index.special_booth')}}</a-menu-item>
                <a-menu-item key="normal_booth">{{$t('index.normal_booth')}}</a-menu-item>
                <a-menu-item key="self_apply">{{$t('index.self_apply')}}</a-menu-item>
            </a-sub-menu>
                <a-menu-item key="setting:1">{{$t('index.special_booth')}}</a-menu-item>
                <a-menu-item key="setting:2">{{$t('index.normal_booth')}}</a-menu-item>
                <a-menu-item key="setting:3">{{$t('index.self_apply')}}</a-menu-item>
                </a-sub-menu>-->
                <a-sub-menu>
                  <span slot="title">{{ $t('index.order_center') }}</span>
                  <a-menu-item key="orinary">
                    <router-link :to="{path: '/order', query: {type: 'ordinary' }}">{{ $t('index.orinary') }}</router-link>
                  </a-menu-item>
                  <template v-if="showInsurance">
                    <a-menu-item
                      v-if="envConfig.envName !== 'baima'"
                      key="index.insurance"
                    >
                      <router-link :to="{path: '/order', query: {type: 'insurance' }}">{{ $t('index.insurance') }}</router-link>
                    </a-menu-item>
                  </template>
                  <a-menu-item key="OrderDocuments">
                    <router-link :to="{path: '/OrderDocuments'}">{{ $t('index.certificateOrder') }}</router-link>
                  </a-menu-item>
                </a-sub-menu>
                <a-menu-item v-if="envConfig.hasOwnProperty('showHelpCenter') ? envConfig.showHelpCenter : true">
                  <a
                    :href="HelpCenterUrl"
                    target="_blank"
                  >{{ $t('index.help_center') }}</a>
                </a-menu-item>
                <a-sub-menu>
                  <span slot="title">
                    {{ $t('index.user_business') }}
                  </span>
                  <a-menu-item-group>
                    <a-menu-item key="personal" @click="$router.push('/personalCenter?type=personal')">
                      <a-icon type="user" />
                      <span>{{ $t('index.personal_center') }}</span>
                    </a-menu-item>
                    <a-menu-item key="enterprise" @click="$router.push('/personalCenter?type=enterprise')">
                      <a-icon type="team" />
                      <span>{{ $t('index.my_business') }}</span>
                    </a-menu-item>
                  </a-menu-item-group>
                </a-sub-menu>
              </a-menu>
            </div>
            <div
              v-show="!isLogin"
              class="header-img"
            >
              <a-button
                type="primary"
                @click="redirectSSOLogin"
              >{{ $t('login.login') }}</a-button>
              <!-- <a-button style="border: 1px solid #d10100;color: #d10100;margin-left: 10px;"><router-link :to="{path: '/login', query: {activeIndex: 1 }}">{{$t('login.register')}}</router-link></a-button> -->
            </div>
            <div
              v-show="isLogin"
              class="header-img"
            >
              <a-dropdown overlay-class-name="overlayClassName">
                <a
                  class="ant-dropdown-link"
                  href="#"
                >
                  <img src="static/home_ic_tx_dhl.png">
                  {{ userInfo.name }}
                  <a-icon type="down" />
                </a>
                <a-menu slot="overlay">
                  <a-menu-item @click="toManage">{{ $t('index.管理后台') }}</a-menu-item>
                  <a-menu-item @click="logout()">{{ $t('index.log_out') }}</a-menu-item>
                </a-menu>
              </a-dropdown>
            </div>
            <div v-if="mainBGC">
              <img
                v-if="localeval=='zh-cn'"
                src="static/home_ic_en.png"
                @click="changeLocale('en-us')"
              >
              <img
                v-else
                src="static/home_ic_zw.png"
                @click="changeLocale('zh-cn')"
              >
            </div>
          </div>
        </div>
      </div>

      <testCheckI18n />

      <div
        :style="indexMainHeight"
        class="index-main"
      >
        <router-view
          v-if="isRouterAlive"
          ref="child"
          @changeMenu="changeMenu"
        />
      </div>
      <div
        v-if="!notFound"
        ref="bottom"
        class="bottom wrapper-back"
      >
        <div class="bottom-wrapper">
          <div class="item-wrapper">
            <div
              v-if="envConfig.envName === 'baima'"
              class="item-wrapper"
            >
              <div class="bottom-item">
                <span class="top-text">{{ $t('index.contact_us') }}</span>
                <span class="item-text">
                  {{ $t('index.address') }}
                </span>
                <span class="item-text">
                  {{ $t('index.phone') }}
                </span>
                <span class="item-text">
                  {{ $t('index.email') }}
                </span>
              </div>
            </div>
            <div
              v-else
              class="item-wrapper"
            >
              <template v-if="envConfig.showFooterInfo">
                <div v-if="agencyConfigPageFooter.business && agencyConfigPageFooter.business.length > 0" class="bottom-item">
                  <span class="top-text">{{ agencyConfigPageFooter.businessAliasName || $t('index.company_bussiness') }}</span>
                  <span v-for="(bus, index) in agencyConfigPageFooter.business" :key="index" class="item-text">
                    <a
                      :href="bus.url"
                      target="_blank"
                    >{{ bus.text }}</a>
                  </span>
                </div>
                <div v-if="agencyConfigPageFooter.services && agencyConfigPageFooter.services.length > 0" class="bottom-item item-left">
                  <span class="top-text">{{ agencyConfigPageFooter.servicesAliasName || $t('index.service_guide') }}</span>
                  <span v-for="(service, index) in agencyConfigPageFooter.services" :key="index" class="item-text">
                    <a
                      :href="service.url"
                      target="_blank"
                    >{{ service.text }}</a>
                  </span>
                </div>
              </template>
            </div>
            <div
              v-if="agencyConfigPageFooter.weQrUrl"
              class="item-wrapper item-right"
            >
              <div class="bottom-item item-img">
                <span class="top-text">{{ agencyConfigPageFooter.weQrAliasName || $t('index.wechat') }}</span>
                <img class="wechatImg" :src="agencyConfigPageFooter.weQrUrl">
              </div>
              <div
                v-if="agencyConfigPageFooter.miniAppQrUrl"
                class="bottom-item item-img"
              >
                <span class="top-text">{{ agencyConfigPageFooter.miniAppQrAliasName || $t('index.miniprogram') }}</span>
                <img class="wechatImg" :src="agencyConfigPageFooter.miniAppQrUrl">
              </div>
            </div>
          </div>
          <div class="copy-text">
            <label for>
              Copyright © {{ agencyConfigPageFooter.year || '2021' }} {{ agencyConfigPageFooter.agencyDisplayName }}
              <a
                target="_blank"
                href="http://beian.miit.gov.cn/"
              >{{ IcpNumber }}</a>
            </label>
            <a
              :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${recordcode}`"
              target="_blank"
              class="copy-text-a"
            >{{ PublicNumber }}</a>
          </div>
        </div>
      </div>
    </div>
  </a-config-provider>
</template>
<script>
import { envConfig } from '@/common/global'
import { delCookie, setCookie } from '../../util/util.js'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import testCheckI18n from '@/component/testCheckI18n.vue'
import moment from 'moment'
import { i18n } from '@/i18n/il8nUtil.js'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
const EN = 'en-us'
const ZH = 'zh-cn'
export default {
  provide() {
    return {
      root: this
    }
  },
  components: {
    testCheckI18n
  },
  data() {
    return {
      localeval: sessionStorage.getItem('locale'),
      locale: zhCN,
      current: ['mail'],
      isLogin: false,
      loginName: '',
      loginMobile: '',
      userInfo: {
        name: '',
        mobile: ''
      },
      isShowBtn: false,
      isFrom3rd: false, // 第三方登录
      mainBGC: false, // 首页背景为全白，其他页面背景为灰
      minWidth: false, // 购物车最小宽度
      isRouterAlive: false,
      notFound: false, // 404页面不显示底部
      company: '深圳市中智兴展览工程有限公司',
      index_logo: {
        CN: '',
        EN: ''
      },
      recordcode: '',
      IcpNumber: '', // 粤ICP备16013905号-2
      PublicNumber: '', // 粤公网安备 44030402003540号
      sp_code: 'static/imgs/qr/shenzhen/sp_code.jpg',
      wx_code: 'static/imgs/qr/shenzhen/wx_code.jpg',
      kefu_qq: '3224763878',
      kefu_qq_url: `http://wpa.qq.com/msgrd?v=3&uin=3224763878&site=qq&menu=yes`,
      showCompanyInfo: true, // 是否显示底部的公司业务和服务指南
      indexMainHeight: {},
      envConfig,
      HelpCenterUrl: '',
      showInsurance: false, // 是否展示订单中心下拉的保险订单
      link: '', // 展馆链接
      saasLink: '', // saas管理后台链接
      indexLogoUrl: '', // agencyLogo 登录页logo
      agencyConfigPageFooter: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      const headerHeight = this.$refs.header.offsetHeight
      const bottomHeight = this.$refs.bottom.offsetHeight
      this.indexMainHeight = {
        'min-height': `calc(100vh - ${headerHeight + bottomHeight}px)`
      }
    })
    this.getLink()
  },
  created() {
    this.getSaasLink()
    this.initConfig()
    if (!sessionStorage.getItem('locale')) {
      sessionStorage.setItem('locale', this.$i18n.locale)
    }
    this.changeLocale(sessionStorage.getItem('locale'))
    if (sessionStorage.getItem('user')) {
      this.isLogin = true
      this.$set(this, 'userInfo', JSON.parse(sessionStorage.getItem('user')))
    }
    this.kefu_qq_url = `http://wpa.qq.com/msgrd?v=3&uin=${envConfig.kefu_qq || this.kefu_qq}&site=qq&menu=yes`
  },
  methods: {
    changeMenu(meun) {
      this.showInsurance = meun.indexOf('保险购买') > -1
    },
    getLink() { // 获取进入展馆链接
      this.$http.get(`${this.api}a/api/sys/rest/dict/dictList/ENTERED_THE_PAVILION`).then(res => {
        const { data: { 0: { value: link }}} = res
        this.link = link
      })
    },
    getSaasLink() { // saas管理后台链接
      // 测试域名 'admin.gl.biscicloud.com'
      const domain = process.env.NODE_ENV === 'production' ? document.location.hostname : 'admin.saas-poly.test.369zhan.com'
      // this.$http.get(`${this.directSaasUrl}/rpc-api/system/ehs/getAgencyByDomain`,
      this.$http.get(`${this.api}a/saas/getAgencyByDomain`,
        { params: { domain }}).then(res => {
        const { code, msg, data } = res.data
        if ((code * 1 !== 0) || !data || !data.tenant) {
          this.$router.push('/page404')
          this.$confirm({
            title: '错误',
            content: '域名[' + domain + ']-' + msg || '域名未配置机构',
            okText: '关闭窗口',
            cancelText: '',
            okCancel: false,
            onOk() {
              window.close()
            }
          })
        } else {
          this.saasLink = document.location.origin + '/web/'
          this.indexLogoUrl = data.agencyLogo || data.loginLogo
          this.$grooveStore.set('ehsAgencyId', data.ehsAgencyId)
          localStorage.setItem('TENANT_ID', data.tenantId)
          // 网站标题更改
          document.title = (data.agencyName || '') + '主场服务平台'
        }
      })
    },
    toManage() {
      // window.open(this.link)
      if (this.saasLink) {
        window.open(this.saasLink)
      } else {
        let origin = document.location.origin
        const protocol = origin.substring(0, origin.indexOf('//') + 2)
        origin = origin.substring(origin.indexOf('.'))
        window.open(protocol + 'admin' + origin + '/web/')
      }
    },
    moment,
    changeLocale(localeval) {
      if (localeval === EN) {
        moment.locale(EN)
        this.$i18n.locale = EN
        this.locale = null
        this.localeval = localeval
        sessionStorage.setItem('locale', EN)
      } else {
        moment.locale(ZH)
        this.$i18n.locale = ZH
        this.localeval = localeval
        this.locale = zhCN
        sessionStorage.setItem('locale', ZH)
      }
      this.reload()
      this.initFooterConfig()
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    routerPush(router) {
      this.$router.push({ name: 'order' })
    },
    logout() {
      this.$http.get(this.api + 'a/logout').then(res => {
        sessionStorage.clear()
        this.isLogin = false
        this.userInfo = {}
        delCookie('JSESSIONID')
        window.location.href =
          this.ssoUrl + 'auth/destroyToken?tokenUrl=' + this.frontUrl
      })
    },
    redirectSSOLogin() {
      // this.ssoUrl:sso登录地址，this.frontUrl主场地址
      window.location.href =
        this.ssoUrl +
        'auth/getVerificationToken?tokenUrl=' +
        window.location.href.split('/#/')[0] +
        `/%23/&platformName=${envConfig.platformName || '主场服务平台'}`
    },
    ssoLogin(param) {
      return new Promise(resolve => {
        this.$http.post(this.api + 'a/ssoLogin', param).then(res => {
          setCookie('JSESSIONID', res.data.data.body.JSESSIONID)
          sessionStorage.setItem(
            'loginName',
            JSON.stringify(res.data.data.body.user.loginName)
          )
          sessionStorage.setItem(
            'refSys',
            JSON.stringify(res.data.data.body.user.refSys)
          )
          if (res.data.data.body.user.refSys !== 'system') {
            this.isFrom3rd = true
            sessionStorage.setItem('isFrom3rd', true)
          }
          resolve(res)
        })
      })
    },
    getUserInfo() {
      return new Promise(resolve => {
        this.$http({
          method: 'get',
          url:
            this.api +
            `a/api/user/getUserInfo?loginName=${JSON.parse(
              sessionStorage.getItem('loginName')
            )}`
        }).then(response => {
          if (response.data.resultCode === 0 || response.data.resultCode === '0') {
            this.isLogin = true
            this.$set(this.userInfo, 'name', response.data.data.name)
            this.$set(this.userInfo, 'email', response.data.data.email)
            this.$set(this.userInfo, 'mobile', response.data.data.mobile)
            this.$set(this.userInfo, 'channel', response.data.data.channel)
            sessionStorage.setItem('user', JSON.stringify(response.data.data))
            resolve(response)
          }
        })
      })
    },
    initConfig() {
      this.initHelpCenterUrl()
      // this.initRecordInfo()
      this.initFooterConfig()
    },
    initHelpCenterUrl() {
      this.$http({
        methods: 'get',
        url: `${this.api}a/api/config/getSysConfigByKey?key=ems.index.helpcenter.url`
      }).then(res => {
        if ((res.data.resultCode === 0 || res.data.resultCode === '0') && res.data.data.length > 0) {
          this.HelpCenterUrl = (res.data.data && res.data.data[0].value) || 'https://www.kancloud.cn/geestu/v002/1071989'
        }
      })
    },
    initRecordInfo() {
      this.$http({
        methods: 'get',
        url: `${this.api}a/api/config/getSysConfigByKey?key=ems.index.footer.filing`
      }).then(res => {
        if ((res.data.resultCode === 0 || res.data.resultCode === '0')) {
          if (res.data.data && res.data.data.length > 0) {
            // const data = JSON.parse(res.data.data[0].value)
            // 因为后端真的返回了一个“}” 总之这样就不报错了
            let data
            try {
              data = JSON.parse(res.data.data[0].value)
            } catch (e) {
              // console.log(e)
              data = { ICP: '', Public: '' }
            }
            const { ICP, Public } = data
            this.IcpNumber = ICP
            this.PublicNumber = Public
            this.recordcode = Public.replace(/[^0-9]/ig, '')
          }
        }
      })
    },
    initFooterConfig() {
      this.$http.get(`${this.api}a/saas/getAgencyConfigPageFooter`).then(res => {
        const { code, data } = res.data
        if ((code * 1 === 0)) {
          console.log('before data===', data)
          i18n(data)
          console.log('after data===', data)
          this.agencyConfigPageFooter = data
          this.$grooveStore.set('agencyConfigPageFooter', data || {})
          this.IcpNumber = data.icpNumber
          this.PublicNumber = data.publicNumber
          if (data.publicNumber) {
            this.recordcode = data.publicNumber.replace(/[^0-9]/ig, '')
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.index-wrapper {
  background-color: #edf0f4;
  min-height: 100vh;
}
.index-wrapper-white {
  background: #fff;
}
.index-wrapper .header {
  height: 60px;
}
.minWidth {
  min-width: 1660px;
}
.index-wrapper .wrapper-back {
  width: 100%;
  background-color: #101528;
  color: #fff;
}
.index-wrapper .header-main {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 60px;
  justify-content: space-between;
}
.index-wrapper .header-img {
  margin-left: 26px;
  margin-right: 50px;
}
.index-wrapper .ant-menu-horizontal {
  white-space: nowrap;
  background: #101528;
  color: #fff;
  border-bottom: 0px;
}
.index-wrapper .ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  color: #fff;
  background: #444a58;
  border: 0px;
}
.index-wrapper .ant-menu-horizontal > .ant-menu-item,
.ant-menu-horizontal > .ant-menu-submenu {
  border: 0px;
}
.index-wrapper .ant-menu-horizontal > .ant-menu-item > a {
  display: block;
  color: #fff;
}
.index-wrapper .bottom-wrapper {
  width: 1100px;
  margin: 0 auto;
  color: #8f8f91;
  padding: 40px 70px 30px 70px;
}
.index-wrapper .bottom-item {
  display: flex;
  flex-direction: column;
}
.index-wrapper .item-wrapper {
  display: flex;
  justify-content: space-between;
}
.index-wrapper .top-text {
  color: #fff;
  font-size: 18px;
  padding-bottom: 24px;
  line-height: 18px;
}
.index-wrapper .item-text {
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 14px;
}
.item-text a {
  color: #8f8f91;
}
.item-text a:hover {
  color: white;
}
.bottom-item img {
  width: 142px;
  height: 142px;
}
.item-right {
  width: 400px;
  text-align: center;
}
.item-left {
  margin-left: 100px;
}
.copy-text {
  text-align: center;
  margin-top: 20px;
}
.index-main {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  box-sizing: border-box;
}
.index_logo {
  max-width: 500px;
}
.index_logo img {
  width: 100%;
}
.copy-text-a {
  margin-left: 10px;
  color: #939393;
}
.overlayClassName ul {
  overflow: hidden;
  padding: 0;
  min-width: 150px;
  margin-top: 15px;
  margin-left: -20px;
  border-radius: 10px;
}
.overlayClassName ul li {
  padding: 10px;
  text-align: center;
}
.wechatImg {
  max-width: 142px;
  max-height: 142px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue